export const AMMO_TYPES = ['Pistol', 'Rifle', 'Shotgun', 'Rimfire'] as const
export const BULLET_TYPES = ['FMJ', 'HP', 'SP', 'BTHP', 'Match', 'Other'] as const

export function normalizeAmmoType (value: string | null | undefined): string {
  if (!value) return AMMO_TYPES[0]
  return AMMO_TYPES.find((t) => t.toLowerCase() === value.trim().toLowerCase()) ?? AMMO_TYPES[0]
}

export function normalizeBulletType (value: string | null | undefined): string {
  if (!value) return BULLET_TYPES[0]
  const key = value.trim().toUpperCase().replace(/[\s-]/g, '')
  const alias: Record<string, string> = {
    JHP: 'HP',
    HPBT: 'BTHP',
    BTHP: 'BTHP',
    FMJ: 'FMJ',
    HP: 'HP',
    SP: 'SP',
    MATCH: 'Match',
    OTHER: 'Other'
  }
  if (alias[key]) return alias[key]
  return BULLET_TYPES.find((t) => t.toLowerCase() === value.trim().toLowerCase()) ?? 'Other'
}
